import { Injectable, Type } from "@angular/core";
import { NatCatalogRepository } from "@natiwi/core/network/repositories/catalog.repository";
import { NatRestAdapter } from "@natiwi/core/network/adapters/rest.adapter";
import { OrmProductSegment } from "@natiwi/shared/models/product-segment.model";

export class NatProductSegmentRepository extends NatCatalogRepository<OrmProductSegment> {

    constructor(adapter?: NatRestAdapter) {
        super(adapter);
        let repoUrl: string = '/productSegments';
        let repoModel: Type<OrmProductSegment> = OrmProductSegment;
        this.init(repoUrl, repoModel);
    }
}